import React from "react";
import { twMerge } from "tailwind-merge";

const InputTextarea = ({
  label,
  value,
  placeholder,
  name,
  updateForm,
  className,
}) => {
  return (
    <div
      className={twMerge(
        `relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px] col-span-3 ${className}`
      )}
    >
      <label className="my-0 font-unilever-shilling-normal text-[13px]">
        {label}*
      </label>
      <textarea
        className="!border !border-[#C8D3DE] p-2 outline-none h-20"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => updateForm(e.target.name, e.target.value)}
      />
    </div>
  );
};

export default InputTextarea;
